import ActionTypes from './action_types.js'

export function initialize(minWidthRatio) {
  return {
    type: ActionTypes.INITIALIZE,
    payload: {
      left: 0,
      right: minWidthRatio,
    },
  }
}

export function changeSize(width, height) {
  return {
    type: ActionTypes.SIZE_CHANGE,
    payload: {
      size: {
        width,
        height,
      },
    },
  }
}

export function cancelFreeScroll() {
  return {
    type: ActionTypes.CANCEL_FREE_SCROLL,
    payload: {},
  }
}

export function startFreeScroll() {
  return {
    type: ActionTypes.START_FREE_SCROLL,
    payload: {},
  }
}

export function updateLeftAndRight(left, right) {
  return {
    type: ActionTypes.UPDATE_LEFT_AND_RIGHT,
    payload: {
      left,
      right,
    },
  }
}

export function drillDownIntoTimelineItem(id, timelineItemType) {
  return {
    type: ActionTypes.TIMELINE_ITEM_DRILL_DOWN,
    payload: {
      id,
      timelineItemType,
    },
  }
}

export function drillOutOfTimelineItem(id, timelineItemType) {
  return {
    type: ActionTypes.TIMELINE_ITEM_DRILL_OUT,
    payload: {
      id,
      timelineItemType,
    },
  }
}
